function openDesktopNav(trigger) {
    var container        = trigger.closest('.trigger-container, .utility-nav-item'),
        menu             = container.find('.meganav-trigger, .utility-trigger'),
        submenuContainer = container.find('.meganav-submenu-container, .utility-sub'),
        submenu          = submenuContainer.find('.meganav-submenu-inner-wrapper, .utility-sub-inner'),
        interactives     = submenu.find('[tabindex]');

    menu.addClass('open').attr('aria-expanded', 'true');
    submenuContainer.addClass('open');
    submenu.addClass('submenu-open').attr('aria-hidden', 'false');
    interactives.attr('tabindex', '0');
}

function closeDesktopNav(trigger) {
    var container        = trigger.closest('.trigger-container, .utility-nav-item'),
        menu             = container.find('.meganav-trigger, .utility-trigger'),
        submenuContainer = container.find('.meganav-submenu-container, .utility-sub'),
        submenu          = submenuContainer.find('.meganav-submenu-inner-wrapper, .utility-sub-inner'),
        interactives     = submenu.find('[tabindex]');

    menu.removeClass('open').removeAttr('aria-expanded');
    submenuContainer.removeClass('open');
    submenu.removeClass('submenu-open').attr('aria-hidden', 'true');
    interactives.attr('tabindex', '-1');
}

function closeAllDesktopMainNavs() {
    $('.top-subnav .trigger-container > .meganav-trigger').each(function () {
        closeDesktopNav($(this));
    });
}

function closeAllDesktopUtilityNavs() {
    $('.top-utility .utility-nav-item > .utility-trigger').each(function () {
        closeDesktopNav($(this));
    });
}

function openLoginDropdown(trigger) {
    var container         = trigger.closest('.login-box, .mobile-nav-area .nav-top'),
        button            = container.find('.login-dropdown'),
        dropdownContainer = container.find('.login-dropdown-container'),
        interactives      = dropdownContainer.find('[tabindex]');

    button.addClass('open').attr('aria-expanded', 'true');
    dropdownContainer.addClass('open').attr('aria-hidden', 'false');
    interactives.attr('tabindex', '0');
}

function closeLoginDropdown(trigger) {
    var container         = trigger.closest('.login-box, .mobile-nav-area .nav-top'),
        button            = container.find('.login-dropdown'),
        dropdownContainer = container.find('.login-dropdown-container'),
        interactives      = dropdownContainer.find('[tabindex]');

    button.removeClass('open').removeAttr('aria-expanded');
    dropdownContainer.removeClass('open').attr('aria-hidden', 'true');
    interactives.attr('tabindex', '-1');
}

function closeAllDesktopDropdowns() {
    closeAllDesktopMainNavs();

    closeAllDesktopUtilityNavs();

    closeLoginDropdown($('#mainNav .login-dropdown'));

    closeDesktopLocationSelect($('[data-js="current-location"]'));
}

function openDesktopLocationSelect(trigger) {
    var container        = trigger.closest('[data-js="my-location"]'),
        current          = container.find('[data-js="current-location"]'),
        choicesContainer = container.find('[data-js="utility-location-choices"]'),
        interactives     = choicesContainer.find('[tabindex]');

    choicesContainer.show().attr('aria-hidden', 'false');
    current.attr('aria-expanded', 'true');
    interactives.attr('tabindex', '0');
}

function closeDesktopLocationSelect(trigger) {
    var container        = trigger.closest('[data-js="my-location"]'),
        current          = container.find('[data-js="current-location"]'),
        choicesContainer = container.find('[data-js="utility-location-choices"]'),
        interactives     = choicesContainer.find('[tabindex]');

    choicesContainer.hide().attr('aria-hidden', 'true');
    current.attr('aria-expanded', 'false');
    interactives.attr('tabindex', '-1');
}

export {
    openDesktopNav,
    closeDesktopNav,
    closeAllDesktopMainNavs,
    closeAllDesktopUtilityNavs,
    openLoginDropdown,
    closeLoginDropdown,
    closeAllDesktopDropdowns,
    openDesktopLocationSelect,
    closeDesktopLocationSelect
};